import type { NodeReading } from "../types/nodes";

// Пороги и эвристики тревог по показаниям метеостанции - общие для Live
// (NodesSection.vue) и чипа «Условия сейчас» в карточке маршрута.
// WIND_WINDY_MS (~Бофорт 5) - типичный порог «ветрено» у погодных сервисов,
// WIND_STRONG_MS - порог опасного явления (сильный ветер), WIND_GUST_DIFF_MS -
// порывы заметно сильнее среднего ветра.
export const WIND_WINDY_MS = 8;
export const WIND_STRONG_MS = 15;
export const WIND_GUST_DIFF_MS = 5;

export type RainStatus = "raining" | "possible" | null;
export type StationAlert = "raining" | "rainPossible" | "windStrong" | "windy" | "windGusty";

// «Идёт дождь» - измерено; «возможен» - воздух почти насыщен (≤1.5°C до
// точки росы при влажности ≥90%). Истории показаний нет, трендов тоже.
export const rainStatus = (r?: NodeReading | null): RainStatus => {
  if (!r) return null;
  if (r.rain_rate_mm_hr != null && r.rain_rate_mm_hr > 0) return "raining";
  if (
    r.humidity_pct != null && r.humidity_pct >= 90 &&
    r.temp_c != null && r.dew_point_c != null &&
    r.temp_c - r.dew_point_c <= 1.5
  ) return "possible";
  return null;
};

export const stationAlerts = (r?: NodeReading | null): StationAlert[] => {
  if (!r) return [];
  const out: StationAlert[] = [];
  const rain = rainStatus(r);
  if (rain === "raining") out.push("raining");
  else if (rain === "possible") out.push("rainPossible");
  if (r.wind_speed_ms != null) {
    if (r.wind_speed_ms >= WIND_STRONG_MS) out.push("windStrong");
    else if (r.wind_speed_ms >= WIND_WINDY_MS) out.push("windy");
  }
  if (r.wind_gust_ms != null && r.wind_speed_ms != null && r.wind_gust_ms - r.wind_speed_ms >= WIND_GUST_DIFF_MS) {
    out.push("windGusty");
  }
  return out;
};
